import type { IFavoriteList } from '../project/types.d';
import { FavoriteList } from './lib/favorite-list';
import { TagCarousel } from './lib/tag-carousel';

const { Aria, Const, Data, Member, Util } = window.Project;

// 絞り込み結果の件数を表示する。
function setResultCounts() {
  const el = Util.all('[data-result-count]');
  if (!el) {
    return;
  }
  const count = FavoriteList.movies.length.toLocaleString();
  el.forEach(
    (a) => (
      a.innerText = String(count)
    )
  );
}

// スマホの時の、動画リストのタグボタン(アコーディオン)を制御する。
function handleExpandableTags(this: HTMLButtonElement) {
  const expanded = Aria(this).expanded;
  const context = this.closest('.expandableTags')!;
  context.classList.toggle('expandableTags-on', !expanded);
  Aria(this).toggle('expanded');
}

Util.delegate('click', '.expandableTags .g-btn-toggle', handleExpandableTags);

(async () => {
  if (Member.redirect()) return;
  if (Member.isLoggedIn()) {
    // お気に入り一覧の取得
    const favorites = (await Member.favoriteList()) as IFavoriteList;
    if (!Member.favoriteError(favorites)) {
      // 動画一覧の取得
      try {
        const master = await Data.fetchMaster();
        const movies = master.movies.filter((movie) =>
          (favorites.favorite_list ?? []).some((favorite) => favorite.page_url === movie[Const.MOVIE.URL])
        );

        // moviesをfavorite_list.created_atの降順にソート
        movies.sort((a, b) => {
          const ac = (favorites.favorite_list ?? []).find((favorite) => favorite.page_url === a[Const.MOVIE.URL])?.created_at;
          const bc = (favorites.favorite_list ?? []).find((favorite) => favorite.page_url === b[Const.MOVIE.URL])?.created_at;
          return Date.parse(bc ?? '') - Date.parse(ac ?? '');
        });

        FavoriteList.movies = movies;
      } catch (error) {
        console.error('Error fetching master data:', error);
      }
    }
    await FavoriteList.refresh({
    });
    setResultCounts();
    TagCarousel.init();
  }
})();

export {};
